import { FC } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { Icon } from '@/components/icon.tsx'

type InfomerProps = {
  type: 'warning'
  title: string
  description: string
}

export const Infomer: FC<InfomerProps> = ({ type, description, title }) => {
  return (
    <Box sx={{ backgroundColor: `infomer.${type}.bg`, p: '12px', borderRadius: '8px' }}>
      <Stack spacing={1} direction="row" alignItems="flex-start">
        <Icon name="Warning" size="px16" colorScheme="icons.yellow" />
        <Stack spacing={1} direction="column">
          <Typography variant="caption" color={`infomer.${type}.text`} fontWeight={600}>
            {title}
          </Typography>
          <Typography variant="caption" color={`infomer.${type}.text`} fontWeight={400}>
            {description}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  )
}
